// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BxbBuPfHW2TU83 {
  position: relative;
}
.etR0OWTAgKlwj3 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  position: relative;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-around;
  min-width: 95px;
  height: 32px;
  margin: 4px 0 2px 8px;
  padding: 6px 12px 6px 12px;
  border: none;
  border-radius: 3px;
  background-color: var(--ds-background-neutral, #091e420f);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  -webkit-user-select: none;
          user-select: none;
}
.etR0OWTAgKlwj3:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
}
.mac .etR0OWTAgKlwj3:focus {
  outline-color: -webkit-focus-ring-color;
}
.etR0OWTAgKlwj3:focus .mac.firefox {
  outline-color: AccentColor;
}
.mhrdimCmqj7Sjy {
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `BxbBuPfHW2TU83`,
	"button": `etR0OWTAgKlwj3`,
	"prompt": `mhrdimCmqj7Sjy`
};
export default ___CSS_LOADER_EXPORT___;
